import { render, staticRenderFns } from "./editCtg.vue?vue&type=template&id=2bec9e57&scoped=true&"
import script from "./editCtg.vue?vue&type=script&lang=js&"
export * from "./editCtg.vue?vue&type=script&lang=js&"
import style0 from "./editCtg.vue?vue&type=style&index=0&id=2bec9e57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec9e57",
  null
  
)

export default component.exports